/**
 * CalendarSkeleton — the calendar while its appointments load: grey pulsing bars in the frame the loaded grid fills,
 * so nothing jumps when the data lands (the Practice calendar's loading look), plus a centred spinner and
 * "Loading appointments…" so the wait reads as a wait (Antonin, 16 Oct: "calendar loading is unclear"). The bars are
 * the DS `Skeleton` (its pulse stops under reduced motion); the spinner is the DS `BrandSpinner`; the frame is
 * `.cal-skeleton*` in the bridge. The grid (and its "Nothing booked" hints) is not mounted while this shows.
 */
import { BrandSpinner, Skeleton } from '@scripsteam/scrips-signal-ds';

const ROWS = [0, 1, 2, 3, 4, 5, 6, 7];

export function CalendarSkeleton() {
  return (
    <div data-slot="pa-calendar-page-loading" role="status" aria-busy="true" aria-label="Loading appointments" className="cal-skeleton">
      {ROWS.map((r) => (
        <div key={r} className="cal-skeleton-row" aria-hidden="true">
          <Skeleton className="cal-skeleton-hour" />
          <Skeleton className="cal-skeleton-card" />
        </div>
      ))}
      <div className="cal-loading-note" data-slot="pa-calendar-loading-note">
        <BrandSpinner size={32} label="Loading appointments" />
        <span aria-hidden="true">Loading appointments…</span>
      </div>
    </div>
  );
}
